import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../lib/cn.js';
import { Field } from '../Field/Field.js';
import styles from './Textarea.module.css';
/** Multi-line field, `min-height:64px`, no manual resize handle (CLAUDE_DESIGN.md §6.2). */
export const Textarea = forwardRef(function Textarea({ label, error, hint, required, className, containerClassName, ...rest }, ref) {
    return (_jsx(Field, { label: label, error: error, hint: hint, required: required, className: containerClassName, children: (fieldProps) => (_jsx("textarea", { ...rest, ...fieldProps, ref: ref, className: cn(styles['textarea'], error && styles['invalid'], className) })) }));
});
